export const COOKIE_CONSENT_KEY = "cookie_consent";
export const CONSENT_CHANGE_EVENT = "kewordal:consent-change";
const CONSENT_EXPIRY_DAYS = 365;

export const getCookieConsent = () => {
  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) return null;
    const consent = JSON.parse(stored);
    return consent?.expiry && new Date(consent.expiry) > new Date()
      ? consent
      : null;
  } catch {
    return null;
  }
};

export const saveCookieConsent = (consent) => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + CONSENT_EXPIRY_DAYS);
  const savedConsent = { ...consent, expiry: expiryDate.toISOString() };
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(savedConsent));
  window.dispatchEvent(
    new CustomEvent(CONSENT_CHANGE_EVENT, { detail: savedConsent }),
  );
};

export const hasAnalyticsConsent = () => getCookieConsent()?.analytics === true;
export const hasMarketingConsent = () => getCookieConsent()?.marketing === true;
